import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../Config/config';
import AddQuestionForm from './AddQuestionForm';
import EditQuestionForm from './EditQuestionForm';

const AdminQuestionManager = () => {
 const { technology } = useParams();
 const [questions, setQuestions] = useState([]);
 const [loading, setLoading] = useState(true);
 const [editingQuestion, setEditingQuestion] = useState(null);

 const fetchAllQuestions = async () => {
 const limit = 100;
 let offset = 0;
 let allQuestions = [];
 let hasMore = true;

 try {
 while (hasMore) {
 const res = await axios.get(`${API_BASE_URL}/admin-questions`, {
 params: { technology, limit, offset }
 });

 const batch = res.data;
 allQuestions = [...allQuestions, ...batch];
 offset += limit;

 if (batch.length < limit) {
 hasMore = false;
 }
 }

 console.log('Total Questions Fetched:', allQuestions.length);
 setQuestions(allQuestions);
 setLoading(false);
 } catch (err) {
 console.error('Error fetching questions:', err);
 setLoading(false);
 }
 };

 useEffect(() => {
 fetchAllQuestions();
 }, [technology]);

 const handleAdd = (newQuestion) => {
 setQuestions((prev) => [...prev, newQuestion]);
 };

 const handleUpdate = (updatedQuestion) => {
 setQuestions((prev) =>
 prev.map((q) => (q.id === updatedQuestion.id ? updatedQuestion : q))
 );
 };

 const handleDelete = async (id) => {
 if (window.confirm('Are you sure you want to delete this question?')) {
 try {
 await axios.delete(`${API_BASE_URL}/admin-questions/delete/${id}`, {
 headers: {
 'Content-Type': 'application/json',
 },
 });
 setQuestions((prev) => prev.filter((q) => q.id !== id));
 } catch (err) {
 console.error('Error deleting question:', err);
 alert('Failed to delete question. Please check backend or API URL.');
 }
 }
};

 return (
 <div className="min-h-screen bg-bgMain text-body p-8">
 <h1 className="text-3xl font-extrabold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent mb-8">
 Manage Questions: {technology}
 </h1>

 <AddQuestionForm onAdd={handleAdd} track={technology} />

 {loading ? (
 <div className="flex items-center gap-3 animate-pulse text-primary">
 <div className="w-5 h-5 border-2 border-primary/30 border-t-secondary rounded-full animate-spin"></div>
 Loading questions...
 </div>
 ) : (
 questions.map((q, index) => (
 <div
 key={q.id}
 className="mb-6 p-6 bg-bgSection rounded-2xl border border-accentGray/30 shadow-xl hover:border-primary/30 transition-all"
 >
 <div className="flex justify-between items-start gap-4">
 <h2 className="text-xl font-bold mb-4 text-body">
 {index + 1}. {q.question}
 </h2>
 <div className="flex gap-2 shrink-0">
 <button
 className="bg-primary/10 text-primary border border-primary/30 px-4 py-1.5 rounded-lg font-bold hover:bg-primary hover:text-white transition-all text-sm"
 onClick={() => setEditingQuestion(q)}
 >
 Edit
 </button>
 <button
 className="bg-red-500/10 text-red-400 border border-red-500/30 px-4 py-1.5 rounded-lg font-bold hover:bg-red-500 hover:text-white transition-all text-sm"
 onClick={() => handleDelete(q.id)}
 >
 Delete
 </button>
 </div>
 </div>
 <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
 <div className="p-3 rounded-xl bg-bgSoft border border-accentGray/30">
 <span className="text-primary font-bold mr-2">A.</span> {q.option_a}
 </div>
 <div className="p-3 rounded-xl bg-bgSoft border border-accentGray/30">
 <span className="text-primary font-bold mr-2">B.</span> {q.option_b}
 </div>
 <div className="p-3 rounded-xl bg-bgSoft border border-accentGray/30">
 <span className="text-primary font-bold mr-2">C.</span> {q.option_c}
 </div>
 <div className="p-3 rounded-xl bg-bgSoft border border-accentGray/30">
 <span className="text-primary font-bold mr-2">D.</span> {q.option_d}
 </div>
 </div>
 <div className="mt-6 flex items-center gap-2">
 <div className="px-4 py-1.5 rounded-full bg-green-500/10 border border-green-500/30 text-green-400 text-sm font-bold">
 Correct Answer: {q.correct_option}
 </div>
 </div>

 {editingQuestion && editingQuestion.id === q.id && (
 <EditQuestionForm
 question={editingQuestion}
 track={technology}
 onClose={() => setEditingQuestion(null)}
 onUpdate={handleUpdate}
 />
 )}
 </div>
 ))
 )}
 </div>
 );
};

export default AdminQuestionManager;



